// extracted by mini-css-extract-plugin
export default {"container":"BackgroundImage_container__c5cYw"};